import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * CONTENT only — never geometry. A move is not an update: the whole arrangement
 * travels once, in the trailing reorder, so dragging one tile does not emit an
 * update for every tile that reflowed around it.
 */
export interface UpdateLinkTilePayload {
    readonly uid: string;
    readonly text: string;
    readonly color?: string;
    readonly icon?: string;
    readonly target?: string;
    readonly imageAssetUid?: string;
}

export class UpdateLinkTileCommand extends AbstractCommand<UpdateLinkTilePayload> {

    public name = CommandName.UPDATE_LINK_TILE;

    public tags: string[] = [`entity`, `update`, `link-tile`];

    constructor(payload: UpdateLinkTilePayload) {
        super('link-tile', payload.uid, payload);
    }
}
